import { FilterOption } from '../../types/types';
import settingsParams from '../../components/BookOnline/settingsParams';

export type HeaderViewModel = {
  isTitleVisible: boolean;
  isListFilterVisible: boolean;
};

export const createHeaderViewModel = (
  settings: any,
  filterOptions: FilterOption[],
): HeaderViewModel | undefined => {
  const isTitleVisible = settings.get(settingsParams.isTitleVisible);
  const isListFilterVisible =
    settings.get(settingsParams.isListFilterVisible) &&
    filterOptions.length > 1;

  if (isTitleVisible || isListFilterVisible) {
    return {
      isTitleVisible,
      isListFilterVisible,
    };
  }
};
